
module.exports = { 
      attributes: {},
    
      body: "Public dental services are delivered via a range of facilities including mobile dental clinics, school dental clinics and community dental clinics.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/dental-and-oral-health.md"},
     }